import classNames from 'classnames';
import { useMemo } from 'react';
import Slider from 'react-slick';
import Card, { ProductSliderProduct } from './Card';

type Props = {
  title: string;
  products: ProductSliderProduct[];
  showAddToCart?: boolean;
  className?: string;
  starsColor?: string;
  slidesToShow?: number;
  starsSize?: string;
};

const ProductsSlider = ({
  title,
  products,
  showAddToCart = true,
  className = '',
  starsColor = '#FFC107',
  slidesToShow = 4,
  starsSize = '22px',
}) => {
  const sliderSettings = useMemo(() => {
    return {
      slidesToShow,
      slidesToScroll: 1,
      arrows: true,
      variableWidth: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 1920,
          settings: {
            slidesToShow: Math.min(slidesToShow, 3),
            arrows: true,
            infinite: false,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: Math.min(slidesToShow, 3),
            arrows: true,
            infinite: false,
          },
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: Math.min(slidesToShow, 2),
            arrows: true,
            infinite: false,
            variableWidth: false,
          },
        },
        {
          breakpoint: 550,
          settings: {
            slidesToShow: Math.min(slidesToShow, 1),
            arrows: true,
            infinite: false,
            variableWidth: false,
          },
        },
      ],
    };
  }, [slidesToShow]);

  return (
    <section className={classNames('tw:mx-auto tw:max-w-[1150px] tw:py-5', className)}>
      <h2 className='tw:mb-7 tw:text-center tw:font-body tw:text-2xl tw:font-bold'>{title}</h2>

      <div className='tw:relative tw:mx-auto tw:flex tw:justify-center tw:gap-4 tw:md:gap-6'>
        <Slider {...sliderSettings} className='tw:mx-auto tw:w-[calc(100%-100px)] tw:max-w-[1150px]'>
          {products.map((product) => (
            <Card
              product={product}
              key={product.id}
              showAddToCart={showAddToCart}
              starsColor={starsColor}
              starsSize={starsSize}
            />
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default ProductsSlider;
